import React from "react";
import { Card, CardBody } from "reactstrap";
import MyReports from "../../Components/Reports";
import ClientesList from '../../../../services/storageClient.js';
const clientSave = new ClientesList();

/*=============================================
=            Reports && analytics            =
=============================================*/

function StandardReports(props) {
	/**CAMBIAR POR PETICIONES A API */
	const data = [];
	const dataTable = []
	let clientList = JSON.parse(clientSave.getAuthentication('client'));

	let cliet = ''
	let clientIn = ''
	if (clientList.length <= 0) {
		clientIn = `(0)`;
	}
	else {
		clientList.map((e, index) => {
			cliet = `${cliet}${e}${clientList.length - 1 === index ? '' : ','}`;
			return e;
		})
		clientIn = `(${cliet})`;
	}


	return (
		<>
			<Card className="myCard">
				<CardBody>
					<MyReports
						data={data}
						table={dataTable}
						itemsByPage={2}
						user={props._user}
						client={clientIn}
					/>
				</CardBody>
			</Card>
		</>
	);
}

export default StandardReports;
